import { getReference, replaceReferences } from './reference';

/**
 * Template tag that resolves any `{{...}}` tags in the literal.
 *
 * Most call sites pass plain text with no tags at all, which is the intended shape: code that needs
 * a domain word should interpolate `terms.loginGroup.value` directly and get compile-time safety,
 * not route through substitution.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function write(strings: TemplateStringsArray, ...values: any[]) {
  let result = strings[0];
  for (let i = 0; i < values.length; i++) {
    result += String(values[i] ?? '') + strings[i + 1];
  }

  return replaceReferences(result);
}

/**
 * Resolves `{{term key.variant}}` tags in text that arrived at runtime - database content and
 * configuration, principally the server-composed audit descriptions (D-027).
 *
 * Named for what it does rather than for the old "glossary" bucket, which after this work holds no
 * vocabulary at all. Do NOT reach for this from a Lit template with a literal string: that is what
 * the typed `terms` object is for, and it cannot fail at runtime.
 */
export function replaceTerms(text: string) {
  return replaceReferences(text);
}

/* Injects a reference directly into templates that are not already using the `write` command.
 *
 * @param nameAndOther - The reference name, optionally followed by a space and a key.
 * @returns The resolved value, or a visible marker if it does not resolve.
 */
export function reference(nameAndOther: string) {
  return getReference(nameAndOther);
}
